var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2597.904,
    height: 895.433,
    viewBox: "0 0 2597.904 895.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7",
    x: 503.422,
    y: 0.998,
    width: 663.249,
    height: 894.435,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 50,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5",
    x: 231.178,
    y: 0,
    width: 663.249,
    height: 894.435,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 50,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_9",
    x: 0,
    y: 258.861,
    width: 595.671,
    height: 378.711,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 50,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_107_2",
    "data-name": "Component 107 \\u2013 2",
    transform: "translate(70 117.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26095",
    "data-name": "Group 26095"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -70, -118)",
    filter: "url(#Path_7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M96.917,0,0,97.168,229.415,327.217,0,557.27l96.916,97.165L423.249,327.217Z",
    transform: "translate(573.42 118)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -70, -118)",
    filter: "url(#Path_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M96.917,0,0,97.168,229.415,327.217,0,557.27l96.916,97.165L423.249,327.217Z",
    transform: "translate(301.18 118)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -70, -118)",
    filter: "url(#Path_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M70.7,0,0,70.251l68.9,68.46H286.768l68.9-68.46L284.973,0Z",
    transform: "translate(70 375.86)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26085",
    "data-name": "Group 26085",
    transform: "translate(1209.223 183.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136612",
    "data-name": "Path 136612",
    d: "M0,246.867V6.47H56.549l73.086,117.7a114.679,114.679,0,0,1,7.506,14.619,30.352,30.352,0,0,1,2.111,11.153h2.307V6.47h57.325v240.4H142.719l-73.093-117.7a113.236,113.236,0,0,1-7.5-14.613,36.84,36.84,0,0,1-2.5-11.153H57.318V246.867Z",
    transform: "translate(0 34.3)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136613",
    "data-name": "Path 136613",
    d: "M127.041,214.917q-23.86,0-40.775-5.192-16.94-5.189-27.314-17.114-10.389-11.919-15.195-31.154-4.821-19.235-4.815-47.311,0-36.929,9.239-59.044T77.412,23.173q20-9.8,53.09-9.8,32.311,0,50.392,5.388t25.581,18.652q7.506,13.271,7.506,37.121,0,18.847-5,30.959t-17.5,19.036q-12.507,6.928-34.624,9.622t-56.739,2.691H88.573V105.3h44.241q16.921,0,23.267-4.039t6.353-15.193V56.45H129.348q-16.543,0-22.89,3.844t-6.346,15v93.846a109.679,109.679,0,0,0,14.615,2.313q8.083.775,19.625.769a223.405,223.405,0,0,0,32.116-2.313,344.3,344.3,0,0,0,35.589-7.31l6.92,40.007a192.567,192.567,0,0,1-38.084,9.232,304.965,304.965,0,0,1-43.851,3.075",
    transform: "translate(206.483 70.869)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136614",
    "data-name": "Path 136614",
    d: "M70.989,206.417l70.4-111.54,33.855,38.848-43.082,72.692Zm130.8,0L71.758,14.1h63.091l130.02,192.317Zm-9.617-78.855-32.7-40.77L202.553,14.1h61.169Z",
    transform: "translate(376.397 74.749)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136615",
    "data-name": "Path 136615",
    d: "M104.743,56.5H215.92V94.184H104.743Zm61.938,196.93q-19.616,0-29.041-8.463t-9.428-26.541V20.332L185.146,6.1V207.268c4.1.517,8.079.964,11.924,1.349s8.332.706,13.462.958l-3.076,38.848a224.209,224.209,0,0,1-22.505,3.85,164.307,164.307,0,0,1-18.27,1.153",
    transform: "translate(555.367 32.359)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136616",
    "data-name": "Path 136616",
    d: "M128.793,6.47H229.578q38.1,0,55.4,14.625t17.312,46.92q0,19.235-6.548,33.271A52.18,52.18,0,0,1,276.9,123.4v2.306a49.514,49.514,0,0,1,27.118,19.421q10.191,14.424,10.191,34.04,0,32.695-18.466,50.2t-53.467,17.505H128.793Zm57.318,222.709-23.847-23.851h68.473q13.462,0,19.234-7.3t5.772-23.851q0-15.766-5.584-22.313-5.577-6.531-19.038-6.534H179.954v-40H221.12q13.462,0,18.661-6.156,5.18-6.144,5.193-22.307,0-16.532-5-22.691T221.5,48.015h-59.24l23.847-23.844Z",
    transform: "translate(682.884 34.3)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136617",
    "data-name": "Path 136617",
    d: "M196.055,63.852q-18.462,0-25.2-6.541t-6.724-25q0-18.838,6.724-25.577T196.446,0q18.075,0,24.812,6.73,6.721,6.73,6.73,25.577,0,18.46-6.541,25t-25.392,6.541M167.21,95.005l57.318-7.694V281.166H167.21Z",
    transform: "translate(870.274 0)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136618",
    "data-name": "Path 136618",
    d: "M256.575,64.817q23.463,0,39.048,5t24.623,16.541q9.037,11.541,13.077,30.959,4.046,19.433,4.033,48.275,0,29.235-4.033,49.037-4.037,19.821-13.077,31.349t-24.623,16.541q-15.579,4.991-39.048,5-21.156,0-35.576-5.192a48.9,48.9,0,0,1-23.28-17.121q-8.849-11.919-12.888-31.349-4.028-19.415-4.034-48.268,0-28.46,4.034-47.884t12.888-31.16A48.178,48.178,0,0,1,221,69.82q14.417-4.991,35.576-5m46.164,44.242H258.5q-9.623,0-13.077,2.111-3.469,2.117-3.466,7.883V223.289h44.626q9.6,0,12.888-2.111c2.168-1.411,3.264-4.172,3.264-8.274Zm57.318-105.4V261.753h-27.7l-29.62-45V8.665Z",
    transform: "translate(958.624 19.414)",
    fill: "#fdfdfd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.e6f315768ca182be62b3fc1220bcc790.svg";
export { ForwardRef as ReactComponent };